<template>
  <div>
    <b-alert variant="danger" v-if="Object.keys(errors).length > 0" show>
      {{ errors }}
    </b-alert>

    <div v-if="isSearchOpen" class="overlay"></div>

    <section id="header-search" :class="{ searchActive: isSearchOpen }">
      <video v-if="1 === 2" autoplay="autoplay" muted="muted" loop="loop" id="bgVideo"><source src="https://ak2.picdn.net/shutterstock/videos/19353142/preview/stock-footage-runner-woman-running-in-the-sunny-city-park-exercising-outdoors-steadicam-stabilized-shot-slow.webm" type="video/mp4"></video>
      <div class="search-inputs-wrapper">
        <b-row no-gutters>
          <b-col cols="12" md="6" class="offline-training">
            <div class="wrapper">
              <div class="text-center">
                <h1 v-if="1 === 2">{{ $t('homeTitle') }} <b-btn class="cta-customers" variant="info" :to="{ name: `CustomersLanding.${$i18n.i18next.language}` }">{{ $t('buttons.readMore') }}</b-btn></h1>
                <h2 class="text-center">{{ $t('findOfflineServices') }}</h2>
              </div>
              <search class="d-block"
                      :showResults="true"
                      v-on:searchResults="getSearchResults"
                      @openSearch="openSearch"></search>
              <b-btn v-if="1 === 2" class="d-sm-none find-professionals mt-2" variant="primary" :to="{ name: 'Professionals' }">Find professionals</b-btn>
            </div>
          </b-col>

          <b-col cols="12" md="6" class="online-training">
            <div class="wrapper">
              <div class="text-center">
                <h2 class="text-center">{{ $t('findOnlineServices') }}</h2>
              </div>
              <search-online
                      class="d-block"
                      :showResults="true"
                      v-on:searchResults="getSearchResults"
                      @openSearch="openSearch"></search-online>
            </div>
          </b-col>
        </b-row>
      </div>
    </section>

    <b-container>

      <section id="services" class="thumbs">
        <h2>{{ $t('servicesSection.title') }}</h2>
        <b-row>
          <b-col cols="6" sm="6" lg="3" class="col">
            <router-link :to="{ name: `ProfessionalsSearch.${$i18n.i18next.language}`, params: { search: $t('specialities.strengthAndMuscle'), location: '#', service: true }}">
              <span>{{ $t('specialities.strengthAndMuscle') }}</span>
              <img src="https://finefit.s3.eu-north-1.amazonaws.com/images/strength_small.jpg"  />
            </router-link>
          </b-col>
          <b-col cols="6" sm="6" lg="3" class="col">
            <router-link :to="{ name: `ProfessionalsSearch.${$i18n.i18next.language}`, params: { search: $t('specialities.performanceImprovement'), location: '#', service: true }}">
              <span>{{ $t('specialities.performanceImprovement') }}</span>
              <img src="https://finefit.s3.eu-north-1.amazonaws.com/images/performance_improvement_small.jpg"  />
            </router-link>
          </b-col>
          <b-col cols="6" sm="6" lg="3" class="col">
            <router-link :to="{ name: `ProfessionalsSearch.${$i18n.i18next.language}`, params: { search: $t('specialities.weightLoss'), location: '#', service: true }}">
              <span>{{ $t('specialities.weightLoss') }}</span>
              <img src="https://finefit.s3.eu-north-1.amazonaws.com/images/weight_loss_small.jpg"  />
            </router-link>
          </b-col>
          <b-col cols="6" sm="6" lg="3" class="col">
            <router-link :to="{ name: `ProfessionalsSearch.${$i18n.i18next.language}`, params: { search: $t('specialities.wellness'), location: '#', service: true }}">
              <span>{{ $t('specialities.wellness') }}</span>
              <img src="https://finefit.s3.eu-north-1.amazonaws.com/images/wellness_small.jpg"  />
            </router-link>
          </b-col>
        </b-row>
      </section>

      <section>
        <h2>{{ $t('professionalSection.title') }}</h2>
      </section>
    </b-container>

    <section id="professional">
      <b-container>
        <b-row>
          <b-col>
            <h2>
              {{ $t('professionalSection.subTitle') }}
            </h2>
            <p>{{ $t('professionalSection.description') }}</p>
            <b-btn variant="primary" :to="{ name: `ProfessionalsLanding.${$i18n.i18next.language}` }">{{ $t('professionalSection.cta') }}</b-btn>
          </b-col>
        </b-row>
      </b-container>
    </section>

  </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
  import Fuse from 'fuse-js-latest'
  window.Fuse = Fuse

  /* Start of lazy load components config */
  import lazyLoadComponent from '@/util/lazy-load-component'
  import Preloader from '@/app/global/components/Preloader'
  // import SkeletonBox from '@/app/global/components/SkeletonBox'
  const lazyLoadOptions = {
    loading: Preloader,
    loadingData: {
      props: {
        width: '100%',
        height: '2rem'
      }
    }
  }
  /* End of lazy load components config */

  export default {
    name: 'Home',
    components: {
      Multiselect: lazyLoadComponent({...lazyLoadOptions, componentFactory: () => import('vue-multiselect')}),
      Treeselect: lazyLoadComponent({...lazyLoadOptions, componentFactory: () => import('@riophae/vue-treeselect')}),
      Search: lazyLoadComponent({...lazyLoadOptions, componentFactory: () => import('@/app/global/components/Search')}),
      SearchOnline: lazyLoadComponent({...lazyLoadOptions, componentFactory: () => import('@/app/global/components/SearchOnline')})
    },
    data () {
      return {
        errors: {},
        results: [],
        form: {
          services: {
            id: null
          }
        },
        testArray: [
          {
            label: "performanceImprovement",
            id: "performanceImprovement"
          },
          {
            label: "strengthAndMuscle",
            id: "strengthAndMuscle"
          }
        ],
        query: '',
        location: this.$i18n.t('placeholders.defaultLocation'),
        options: {
          shouldSort: true,
          includeScore: true,
          includeMatches: true,
          threshold: 0.1,
          location: 0,
          distance: 10000,
          maxPatternLength: 200,
          minMatchCharLength: 4,
          keys: [
            'displayName',
            'description',
            'fullTextSpecialities',
            'fullTextServices',
            'fullTextCertificates'
          ]
        },
        fuse: null,
        search: '',
        showResults: false,
        isSearchOpen: false
      }
    },
    computed: {
      user: function () {
        return this.$store.getters.user
      },
      allUsers: function () {
        return this.$store.getters.allUsers
      },
      services: function () {
        return this.$store.getters.services
      },
      servicesObject: function () {
        return this.$store.getters.servicesObject
      },
      specialities: function () {
        return this.$store.getters.specialities
      },
      specialitiesObject: function () {
        return this.$store.getters.specialitiesObject
      },
      availableServices: function () {
        if (!_.isEmpty(this.servicesObject)) {
          return this.servicesObject
        }
        return {}
      },
      mainLevelArray: function () {

        let parent = this
        for (var key in this.availableServices) {
          if (this.availableServices.hasOwnProperty(key)) {

            if (key !== 'children') {
              _.set(this.availableServices[key], 'id', key)
              _.set(this.availableServices[key], 'label', this.$i18n.t(`services.${key}`))
            } else {

              let subLevelObj = this._.toArray(this.availableServices[key])

              subLevelObj.forEach( function (arrayItem)
              {
                if (arrayItem.children) {
                  for (var key in arrayItem.children) {
                    if (arrayItem.children.hasOwnProperty(key)) {
                      _.set(arrayItem.children[key], 'id', key)
                      _.set(arrayItem.children[key], 'label', parent.$i18n.t(`services.${key}`))
                    }
                  }
                  arrayItem.children = _.toArray(arrayItem.children)
                }
              })

              for (var key in subLevelObj) {
                if (subLevelObj.hasOwnProperty(key)) {
                  _.set(parent.availableServices['children'][key], 'id', key)
                  _.set(parent.availableServices['children'][key], 'label', parent.$i18n.t(`services.${key}`))
                }
              }
            }
          }
        }
        var array = this._.toArray(this.availableServices)

        return array
      }
    },
    methods: {
      getSearchResults (results) {
        // this.results = results
      },
      generateHighlightedText (text, regions) {
        if (!regions) return text

        var content = '', nextUnhighlightedRegionStartingIndex = 0

        regions.forEach(function (region) {
          content += '' +
            text.substring(nextUnhighlightedRegionStartingIndex, region[0]) +
            '<span class="highlight">' +
            text.substring(region[0], region[1] + 1) +
            '</span>' +
            '';
          nextUnhighlightedRegionStartingIndex = region[1] + 1
        })

        content += text.substring(nextUnhighlightedRegionStartingIndex)

        return content
      },
      addToSearch (value) {
        if (!_.isEmpty(value)) {
//          let existingTxt = this.search
//
//          if (!_.isEmpty(existingTxt)) {
//            this.search = `${existingTxt} ${value}`
//          } else {
//            this.search = value
//          }

          this.search = value
        }
      },
      onOpen () {
        this.showResults = true
      },
      onClose (event) {
        var noClose = 'input#searchInput.form-control'
        if (!event.target.matches(noClose)) {
          this.showResults = false
        }
      },
      openSearch: function (isOpen) {
        this.isSearchOpen = isOpen
      }
    },
    mounted () {
      // this.$el.addEventListener('click', this.onClose)
    },
    watch: {
      isSearchOpen: function (val, oldVal) {
        if (val) {
          // window.scrollTo(0, 0)
          document.body.classList.add('search-open')
        } else {
          document.body.className = document.body.className.replace('search-open', '')
        }
      }
    }
  }
</script>

<style src="@riophae/vue-treeselect/dist/vue-treeselect.min.css"></style>

<style lang="scss">


  body {
    &.search-open {
      @include media-breakpoint-down(sm) {
        overflow-y: hidden;
      }
    }
  }
</style>
<style lang="scss" scoped>


  h1, h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }

  span.highlight {
    /*background-color: yellow;*/
  }

  .popover {
    /*width: 90% !important;
    max-width: 100% !important;
    left: 50% !important;
    transform: translate(-50%, 550px) !important;*/

    h3.popover-header {
      margin-top: 0;
    }

    .dropdown-menu {
      &.show {
        max-height: 250px;
        overflow-y: scroll;
      }
    }

    .btn-group {
      display: block;
      text-align: left;
      margin: 0 !important;

      .btn.dropdown-toggle {
        text-align: left;
        padding-right: 1rem;

        &:after {

        }
      }
    }
  }
  #search-results {
    text-align: left;
    width: 100%;
    max-height: 420px;
    overflow-y: hidden;

    .services,
    .specialities {
      padding: 1rem;
      max-height: 420px;
      overflow-y: scroll;

      .parent,
      .children {
        margin: 0.2rem 0;
      }

      .btn.collapsible {
        .material-icons {
          font-size: 1em;

          &:before {
            content: 'expand_less';
          }
        }

        &.collapsed {
          .material-icons {
            &:before {
              content: 'expand_more';
            }
          }
        }
      }

      .children {
        margin-left: 1rem;
      }
    }

    .results {
      padding: 1rem;
      max-height: 420px;
      overflow-y: scroll;

      a {
        color: black;
        padding-bottom: 1rem;

        .photo-wrapper {
          vertical-align: top;

          img.profile {
            width: 100%;
            height: auto;
            border: 1px solid #ccc;
          }
        }

        .name {
          font-weight: bold;
        }
        .specialities {
          color: #17a2b8;
          font-style: italic;
          padding: 0;
        }
        .matches {

        }
      }
    }
  }

  .overlay {
    @include media-breakpoint-down(sm) {
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      width: 100%;
      height: 100vh;
      background: rgba(0,0,0,0.5);
      z-index: 1;
    }
  }

  #header-search {
    position: relative;
    min-height: 500px;
    background: url(https://finefit.s3.eu-north-1.amazonaws.com/images/hero_home_new.jpg) no-repeat center center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    overflow: visible;

    .search-inputs-wrapper {
      /*position: absolute;
      top: 70%;
      left: 50%;
      transform: translate(-50%, -70%);
      width: 100%;
      z-index: 10;*/
    }

    &.searchActive {
      @include media-breakpoint-down(sm) {
        position: unset;
      }

      .search-inputs-wrapper {
        /*min-width: 320px;

        @include media-breakpoint-down(sm) {
          position: fixed;
          top: 4rem;
          left: 0;
          right: 0;
          transform: unset;

          .intro {
            display: none;
          }
        }*/
      }
    }

    h1, h2 {
      color: white;
      font-size: 2rem;
      font-weight: bold;
      text-align: left;
    }
    h1 {
      display: block;
      padding: 1rem;
      box-sizing: border-box;
      /*background: rgba(0,0,0,0.5);*/
    }

    h2 {
      margin: 1rem;
    }

    .offline-training {
      padding: 0 2rem;
      margin-top: 7rem;

      .wrapper {
        padding: 2rem 2rem;
        background: rgba(0, 0, 0, 0.5);

        @include media-breakpoint-down(sm) {
          padding: 1rem;
        }
      }

      @include media-breakpoint-down(sm) {
        padding: 1rem;
        margin-top: 0;
        background: url(https://finefit.s3.eu-north-1.amazonaws.com/images/hero_home_offline.jpg) no-repeat center center;
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        background-size: cover;
        overflow: visible;
      }
    }

    .online-training {
      padding: 0 2rem;
      margin-top: 7rem;

      .wrapper {
        padding: 2rem 2rem;
        background: rgba(7, 55, 82, 0.5);

        @include media-breakpoint-down(sm) {
          padding: 1rem;
        }
      }

      @include media-breakpoint-down(sm) {
        padding: 1rem;
        margin-top: 0;
        background: url(https://finefit.s3.eu-north-1.amazonaws.com/images/hero_home_online.jpg) no-repeat center center;
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        background-size: cover;
        overflow: visible;
      }
    }

    .cta-customers {
      color: black;
      border: none;
      padding: 0.5rem;
      line-height: 1rem;
      background: white;
    }

    @include media-breakpoint-down(md) {
      padding: 0;
    }
  }

  video#bgVideo {
    position: absolute;
    height: 100%;
    width: 100%;
    -o-object-fit: cover;
    object-fit: cover;
    z-index: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-size: cover;
    overflow: hidden;
  }

  section {
    padding: 1rem 0;
  }

  section.thumbs {
    .col {
      padding: 15px;
    }
    a {
      position: relative;
      color: white !important;
      text-transform: uppercase;
      text-decoration: none;

      span {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border: 1px solid white;
        padding: 0.5rem;
      }
      img {
        width: 100%;
        height: auto;
      }

      &:hover {
        color: white;
        opacity: .9;
      }
    }
  }

  #search-results {
    .services {
      .card {
        border: none;
        border-radius: 0;
      }
      header {
        padding: 0;
        background: transparent;
        border: none;
        border-radius: 0;
      }
      .btn.main-level {
        color: inherit;
        border: none;
        border-radius: 0;
        border-bottom: 2px solid black;
        box-shadow: none;
        background: transparent;
      }
      .btn.second-level {
        border: none;
        box-shadow: none;
      }
      .card-body.third-level {
        padding: 0.5rem 0;

        a.third-level {
          display: block;
          color: black;
          padding: 0.5rem 0;
          border-bottom: 1px solid black;
          white-space: normal;
        }
      }
    }
  }

  section#services {
    .row {
      margin-bottom: -30px;
    }
  }

  #professional {
    position: relative;
    min-height: 400px;
    background: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(https://finefit.s3.eu-north-1.amazonaws.com/images/footer_home.jpg) no-repeat center center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    text-align: center;
    color: white;
    font-size: 1.5rem;

    .container {
      width: 40%;

      h2 {
        margin-top: 6rem;
        text-align: center;
        font-size: 2rem;
        margin-left: auto;
        margin-right: auto;
      }

      @include media-breakpoint-down(md) {
        width: 80%
      }
    }
  }

  .nav{
    list-style:none;
    margin-left:0;
  }
  .nav > li,
  .nav > li > a{
    display:inline-block;
    *display:inline;
    zoom:1;
  }
  .stacked > li{
    display:list-item;
  }
  .stacked > li > a{
    display:block;
  }


  .flyout, .flyout-alt {
    position: relative;
  }

  .flyout-content {
    position: absolute;
    top: 100%;
    left: -99999px;
    height: 0;
    overflow: hidden;
    z-index: 999;
  }

  .flyout:hover > .flyout-content {
    left: 0;
  }

  .flyout-alt:hover > .flyout-content {
    top: 0;
    left: 100%;
  }

  .flyout:hover > .flyout-content, .flyout-alt:hover > .flyout-content {
    height: auto;
    overflow: visible;
  }

  ul.services {
    > li {
      width: 50% !important;
      > ul.flyout-content {
        /*position: relative;*/
        /*width: 100%;*/
        left: 100% !important;
        top: 0 !important;
      }
    }
    font-size: 0.8rem;
    font-family: sans-serif;
    li {
      display: block;
      margin: 0;
      width: 100%;
      margin-left: 0.1rem;
    }
    a {
      line-height: 1;
      padding: 1em;
      padding-left: 0;
      background-color: white;
      color: black;
      border-bottom: 2px solid black !important;
      white-space: nowrap;
      i {
        font-size: 0.8rem;
      }
    }
    .flyout:hover > a, .flyout-alt:hover > a,
    a:hover {
      color: white;
      background-color: $primary;
      text-decoration: none;
    }
    .flyout-alt > a:after {
      content: "";
    }
    a {
      border: 0 solid #fff;
    }
    .flyout-content {
      background-color: white;
      a {
        border-bottom-width: 1px;
      }
    }
    > li {
      > a {

      }
      &:first-child > a {
        border: none;
      }
    }
    .flyout-alt:hover > .flyout-content {
      top: -1px;
    }
  }
</style>

<style lang="scss" scoped>


  h2 {

  }

  .btn.find-professionals {
    width: 100%;
    font-size: 1.2rem;
    font-weight: bold;
  }
</style>
